import {
	Component,
	OnInit,
	Input,
	ViewChild,
	ChangeDetectorRef,
	Inject,
	Optional,
} from "@angular/core";
import { DashboardPorletsService } from "../../dashboardPorlets.service";
import {
	PageSettingsModel,
	GridComponent,
	QueryCellInfoEventArgs,
	ColumnChooserService,
	ExcelExportService,
	FilterSettingsModel,
	ColumnChooserSettingsModel,
	VirtualScrollService,
} from "@syncfusion/ej2-angular-grids";
import { DashboardService } from "../../dashboard.service";
import moment from "moment";
import { Subscription } from "rxjs";
import { DataUtil } from "@syncfusion/ej2-data";
import { PBF_TOKEN } from "../../../service/InjectionToken";
import { getTranslation } from "../../../utils/utils";

@Component({
	selector: "rs-gadget-transpose",
	templateUrl: "./gadget-transpose.component.html",
	styleUrls: ["./gadget-transpose.component.scss"],
	providers: [ExcelExportService, ColumnChooserService, VirtualScrollService],
})
export class GadgetTransposeComponent implements OnInit {
	@Input() portlet;
	@Input() portlets;
	@Input() dashboard;
	@ViewChild("grid", { static: false }) public grid: GridComponent;
	private translation;
	private userInfo;
	public datePipeFormat;
	public fields = [];
	public data;
	public pageSettings: PageSettingsModel;
	public pageLoading = false;
	// public filterSettings: FilterSettingsModel;
	public filter: Object;
	public rowMode: string;
	private formatSettings = [];
	private config;
	private tranposeData;
	private subscriptions: Subscription[] = [];
	private quarterFormat = [
		{ value: "03/2021", format: "MM/yyyy" },
		{ value: "03/21", format: "MM/dd" },
		{ value: "3/2021", format: "M/yyyy" },
		{ value: "3/21", format: "M/yy" },
		{ value: "March 2021", format: "MMMM yyyy" },
		{ value: "Mar, 2021", format: "MMM, yyyy" },
		{ value: "March, 2021", format: "MMMM, yyyy" },
		{ value: "2021", format: "yyyy" },
	];
	private formatDates = [];
	public ColumnChooserSettings: ColumnChooserSettingsModel;

	constructor(
		private DashboardPorletsService: DashboardPorletsService,
		public dashboardService: DashboardService,
		private ref: ChangeDetectorRef,
		@Optional() @Inject(PBF_TOKEN) private pbf: any,
	) {}

	ngOnInit() {
		this.getInfo();
		this.pageSettings = { pageSizes: true, pageSize: 20 };
		this.ColumnChooserSettings = { operator: "contains" };
		this.filter = { type: "CheckBox" };
		this.rowMode = "Vertical";
		this.getTableData();
	}
	ngAfterViewInit() {
		this.subscriptions.push(
			this.dashboardService.getUpdated().subscribe((newId) => {
				if (newId === this.portlet.newId || newId === this.portlet.id) {
					this.getTableData();
				}
			})
		);
		this.subscriptions.push(
			this.dashboardService.getStartRefresh().subscribe((dashboardId) => {
				if (this.dashboard.id === dashboardId) {
					this.pageLoading = true;
					this.ref.markForCheck();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService.getRefreshGadget().subscribe((e) => {
				if (!e) {
					return;
				}
				const id = e["newId"];
				if (id === this.portlet.newId || id === this.portlet.id) {
					this.getTableData();
				}
			})
		);
		this.subscriptions.push(
			this.dashboardService.getTableFormat().subscribe((id) => {
				if (id === this.portlet.newId || id === this.portlet.id) {
					this.getTableData();
					this.grid.columns.forEach((item) => {
						this.fields.forEach((table) => {
							if (
								item.field === table.colName &&
								table.format &&
								table.format.length &&
								table.format[0].formatChecked
							) {
								item.headerText =
									table.displayName ||
									table.langValue ||
									this.translation[table.langCode] ||
									table.langCode;
								if (
									table.format &&
									(table.dataType === "number" ||
										table.dataType === "percent")
								) {
									let formatString;
									if (table.dataType === "number") {
										formatString = this.pbf.formatNumber(
											table.format[0].selectedFormat
										);
									} else if (table.dataType === "percent") {
										formatString = this.pbf.formatPercent(
											table.format[0].selectedFormat
										);
									}
									item.format = formatString;
								}
							}
						});
					});
					this.grid.refreshColumns();
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	private getTableData() {
		this.pageLoading = false;
		this.config = JSON.parse(this.portlet.config);
		if (this.config.fields) {
			let fields = this.config.fields.filter((fl) => !fl.isHidden);
			const fieldsCopy = JSON.parse(JSON.stringify(fields));
			if (fieldsCopy.length) {
				let _index = 0;
				this.fields = fieldsCopy.map((el) => {
					// 处理format的displayName，之前未赋值
					let displayName = "";
					if (
						Array.isArray(el.format) &&
						el.format.length > 0 &&
						el.format[0].formatChecked
					) {
						displayName = el.format[0].displayName;
					}
					if (el.visible) {
						_index += 1;
						return {
							...el,
							_index,
							displayName,
						};
					} else {
						return {
							...el,
							_index: null,
							displayName,
						};
					}
				});
			}
		}
		this.tranposeData = this.DashboardPorletsService.getResultByDataTable(
			this.portlet,
			false,
			false,
			this.dashboard.id
		);
		this.tranposeData = DataUtil.parse.parseJson(this.tranposeData);
		if (this.tranposeData && this.tranposeData.length)
			this.filterData((res) => {
				if (this.config && this.fields && this.fields.length) {
					this.formatSettings = [];
					this.fields.map((el) => {
						let numberTypes = [
							"number",
							"percent",
							"percentNum",
							"multiple",
						];
						if (numberTypes.includes(el.dataType)) {
							let format = this.getNumFormat(el);
							const formatData = {
								name: el.colName,
								format: format,
							};
							// if (el.dataType === "number")
							// 	formatData["useGrouping"] = true;
							this.formatSettings.push(formatData);
						}
						if (
							el.dataType == "datetime" ||
							el.dataType == "date"
						) {
							let format = "";
							if (
								el.format &&
								el.format.length &&
								el.format[0].formatChecked
							) {
								if (el.format[0].compareValue2 == "Quarter") {
									let format_ =
										el.format[0].selectedFormatDisplay;
									let formatInfo = this.quarterFormat.filter(
										(qur) => qur.value == format_
									);
									if (formatInfo.length) {
										format = formatInfo[0].format;
									} else {
										const formatData = {
											name: el.colName,
											format: format_,
											type: "date",
										};
										this.formatDates.push(formatData);
									}
								} else if (
									el.format[0].compareValue2 == "Date"
								) {
									let fromIdx =
										el.format[0].selectedFormatDisplay.indexOf(
											"("
										);
									let toIdx =
										el.format[0].selectedFormatDisplay.indexOf(
											")"
										);
									let format_ =
										el.format[0].selectedFormatDisplay.slice(
											fromIdx + 1,
											toIdx
										);
									switch (format_) {
										case "DD/MM/YYYY":
											format = "dd/MM/yyyy";
											break;
										case "DD/MM/YY":
											format = "dd/MM/yy";
											break;
										case "MM/DD/YYYY":
											format = "MM/dd/yyyy";
											break;
										case "MM/DD/YY":
											format = "MM/dd/yy";
											break;
										case "YYYY-MM-DD":
											format = "yyyy-MM-dd";
											break;
										case "YY-MM-DD":
											format = "yy-MM-dd";
											break;
										case "DD-MM-YYYY":
											format = "dd-MM-yyyy";
											break;
										case "DD-MM-YY":
											format = "dd-MM-yy";
											break;
										case "MM-DD-YYYY":
											format = "MM-dd-yyyy";
											break;
										case "MM-DD-YY":
											format = "MM-dd-yy";
											break;
										case "MMM DD, YYYY":
											format = "MMM dd, yyyy";
											break;
										case "DD-MMM-YYYY":
											format = "dd-MMM-yyyy";
											break;
										default:
											break;
									}
								}
							}
							if (!format) {
								const formatData = {
									name: el.colName,
									format: this.datePipeFormat,
									type: "date",
								};
								this.formatSettings.push(formatData);
							} else {
								const formatData = {
									name: el.colName,
									format: format,
									type: "date",
								};
								this.formatSettings.push(formatData);
							}
						}
					});
				}
				if (this.grid) this.grid.refresh();
				this.ref.markForCheck();
				this.ref.detectChanges();
			});
	}

	private filterData(callback) {
		this.data = [];
		if (this.config.filterSettings && this.config.filterSettings.length) {
			if (this.tranposeData) {
				let dataType = this.fields.filter(
					(el) => el.colName == this.config.filterSettings[0].field
				).length
					? this.fields.filter(
							(el) =>
								el.colName ==
								this.config.filterSettings[0].field
					  )[0].dataType
					: "";
				let transpose_data = [];
				if (dataType == "date" || dataType == "datetime") {
					transpose_data = this.tranposeData.filter(
						(el) =>
							moment(
								el[this.config.filterSettings[0].field]
							).format("YYYY-MM-DD") ==
							moment(this.config.filterSettings[0].value).format(
								"YYYY-MM-DD"
							)
					);
				} else {
					transpose_data = this.tranposeData.filter(
						(el) =>
							el[this.config.filterSettings[0].field] ==
							this.config.filterSettings[0].value
					);
				}
				if (transpose_data.length) {
					this.data.push(transpose_data[0]);
				} else {
					this.data.push(this.tranposeData[0]);
				}
			}
		} else {
			this.data.push(this.tranposeData[0]);
		}
		// if (this.grid) this.grid.refresh();
		callback();
	}

	private getInfo() {
		this.translation = getTranslation()
		this.datePipeFormat = localStorage.getItem("datePipe");
	}
	getFormatOptions(colName) {
		let res = this.formatSettings.filter((el) => el.name === colName);
		if (res && res.length) {
			// let obj = JSON.parse(JSON.stringify(res[0]));
			// delete obj.name;
			// return obj;
			return res[0].format;
		}
	}

	customiseCell(args: QueryCellInfoEventArgs) {
		let queryCell = this.fields.filter(
			(item) => item.colName === args.column.field
		)[0];
		if (
			queryCell &&
			queryCell.format &&
			queryCell.format.length &&
			queryCell.format[0].formatChecked
		) {
			// SMP2-3416 0的format start
			if (
				[2, 5, 8, 11, 14, 17].includes(
					queryCell.format[0].selectedFormat
				) &&
				args.data[queryCell.colName] === 0
			)
				args.cell.innerHTML = "-";
			if (
				[3, 6, 9, 12, 15, 18].includes(
					queryCell.format[0].selectedFormat
				) &&
				args.data[queryCell.colName] === 0
			)
				args.cell.innerHTML = "";
			// SMP2-3416 0的format end
		}
		if (queryCell && queryCell._index) {
			if (queryCell._index === 1) {
				args.cell.classList.add("first-cell");
			}
			// args.cell.classList.add(
			// 	`${queryCell._index % 2 === 0 ? "even" : "odd"}`
			// );
			this.ref.markForCheck();
		}
		if (
			queryCell &&
			queryCell.format &&
			queryCell.format.length &&
			queryCell.format[0].fontSettingChecked
		) {
			if (
				queryCell.format[0].formatChecked &&
				queryCell.format[0].compareSelect
			) {
				let cellData = args.data[args.column.field];
				let condition: Boolean = false;
				switch (queryCell.format[0].compareSelect) {
					case "LessThan":
						condition =
							cellData <
							Number(queryCell.format[0].compareValue1);
						break;
					case "LessThanOrEqualTo":
						condition =
							cellData <=
							Number(queryCell.format[0].compareValue1);
						break;
					case "GreaterThan":
						condition =
							cellData >
							Number(queryCell.format[0].compareValue1);
						break;
					case "GreaterThanOrEqualTo":
						condition =
							cellData >=
							Number(queryCell.format[0].compareValue1);
						break;
					case "Equals":
						condition =
							cellData ===
							Number(queryCell.format[0].compareValue1);
						break;
					case "NotEquals":
						condition =
							cellData !==
							Number(queryCell.format[0].compareValue1);
						break;
					case "Between":
						condition =
							cellData >=
								Number(queryCell.format[0].compareValue1) &&
							cellData <= queryCell.format[0].compareValue2;
						break;
					case "NotBetween":
						condition =
							cellData <
								Number(queryCell.format[0].compareValue1) &&
							cellData >
								Number(queryCell.format[0].compareValue2);
						break;
					default:
						break;
				}
				if (condition) this.cellAddStyle(args, queryCell);
			} else this.cellAddStyle(args, queryCell);
		}

		// date format about quarterly

		if (this.formatDates && this.formatDates.length) {
			let dateFields = this.formatDates.map((el) => {
				return el.name;
			});
			if (
				args.column.field &&
				dateFields.includes(args.column.field) &&
				queryCell.format &&
				queryCell.format.length &&
				queryCell.format[0].formatChecked
			) {
				let date = new Date(args.data[args.column.field]);

				let quarter =
					Math.floor((date.getMonth() + 1) % 3) == 0
						? Math.floor((date.getMonth() + 1) / 3)
						: Math.floor((date.getMonth() + 1) / 3) + 1;

				let format;

				this.formatDates.map((el) => {
					if (el.name == args.column.field) format = el.format;
				});
				let year: any;
				switch (format) {
					case "Q1 2021":
						year = date.getFullYear();
						args.cell.innerHTML = "Q" + quarter + " " + year;
						break;
					case "Q1 21":
						year = (date as any).getYear() - 100;
						args.cell.innerHTML = "Q" + quarter + " " + year;
						break;
					case "2021 Q1":
						year = date.getFullYear();
						args.cell.innerHTML = year + " " + "Q" + quarter;
						break;
					case "21 Q1":
						year = (date as any).getYear() - 100;
						args.cell.innerHTML = year + " " + "Q" + quarter;
						break;
				}
			}
		}
	}

	cellAddStyle(args, queryCell) {
		if (queryCell.format[0].fontSettingChecked) {
			let formatCellData = args.data[args.column.field];
			if (Math.sign(formatCellData) !== 0)
				if (Math.sign(formatCellData) === -1) {
					args.cell.style.cssText += `color: ${queryCell.format[0].negaFontColor} !important`;
					args.cell.style.cssText += `font-size: ${queryCell.format[0].negaFontSizeValue} !important`;
					args.cell.style.cssText += `font-family: ${queryCell.format[0].negaFontFamilyValue} !important`;
					args.cell.style.cssText += `background-color: ${queryCell.format[0].negaBackgroundColor} !important`;
				} else {
					args.cell.style.cssText += `color: ${queryCell.format[0].fontColor} !important`;
					args.cell.style.cssText += `font-size: ${queryCell.format[0].fontSizeValue} !important`;
					args.cell.style.cssText += `font-family: ${queryCell.format[0].fontFamilyValue} !important`;
					args.cell.style.cssText += `background-color: ${queryCell.format[0].backgroundColor} !important`;
				}
		}
	}

	actionComplete(args) {
		if (args.requestType === "columnstate") {
			const hideColumns = this.grid.getHiddenColumns();
			this.fields.map((el) => (el.visible = true));
			if (hideColumns.length > 0) {
				for (let hideitem of hideColumns) {
					this.fields.forEach((field) => {
						if (field.colName === hideitem.field) {
							field.visible = false;
							field._index = null;
						}
					});
				}
			}

			let _index = 0;
			this.fields.forEach((field) => {
				if (field.visible) {
					_index += 1;
					field._index = _index;
				}
			});
			this.config.fields = JSON.parse(JSON.stringify(this.fields));
			const portlet = this.portlet;
			portlet.config = JSON.stringify(this.config);
			const index = this.portlets.findIndex(
				(x) => x.newId === portlet.newId
			);
			this.portlets[index].config = JSON.stringify(this.config);

			if (this.grid) this.grid.refresh();
		}
	}
	exportQueryCellInfo(args): void {
		if (this.formatDates && this.formatDates.length) {
			let dateFields = this.formatDates.map((el) => {
				return el.name;
			});

			if (args.column.field && dateFields.includes(args.column.field)) {
				let date = new Date(args.data[args.column.field]);

				let quarter =
					Math.floor((date.getMonth() + 1) % 3) == 0
						? Math.floor((date.getMonth() + 1) / 3)
						: Math.floor((date.getMonth() + 1) / 3) + 1;

				let format;

				this.formatDates.map((el) => {
					if (el.name == args.column.field) format = el.format;
				});
				let year: any;
				switch (format) {
					case "Q1 2021":
						year = date.getFullYear();
						args.value = "Q" + quarter + " " + year;
						break;
					case "Q1 21":
						year = (date as any).getYear() - 100;
						args.value = "Q" + quarter + " " + year;
						break;
					case "2021 Q1":
						year = date.getFullYear();
						args.value = year + " " + "Q" + quarter;
						break;
					case "21 Q1":
						year = (date as any).getYear() - 100;
						args.value = year + " " + "Q" + quarter;
						break;
				}
			}
		}
	}

	private getNumFormat(el) {
		//SMP2-3026
		if (
			el.dataType === "number" &&
			el.colName !== "PortInvStk" &&
			el.colName !== "PortFdInvStk"
		) {
			if (el.format && el.format.length && el.format[0].formatChecked) {
				if (
					[10, 11, 12, 13, 14, 15, 16, 17, 18].includes(
						el.format[0].selectedFormat
					)
				)
					this.millionData(el.colName);
				return this.pbf.formatNumber(el.format[0].selectedFormat);
			} else return this.DashboardPorletsService.formatNumber(el.dp);
		}
		if (el.dataType === "percent") {
			if (el.format && el.format.length && el.format[0].formatChecked)
				return this.pbf.formatPercent(el.format[0].selectedFormat);
			else return this.DashboardPorletsService.formatPercent(el.dp);
		}
		if (el.dataType === "percentNum")
			return this.DashboardPorletsService.formatPercentNum(el.dp);
		if (el.dataType === "multiple")
			return this.DashboardPorletsService.formatMultiple(el.dp);
	}

	private millionData(colName) {
		this.data.map((el) => {
			el[colName] = Number(el[colName] / 1000000);
		});
		if (this.config.filterSettings && this.config.filterSettings.length) {
			let filterFields = this.config.filterSettings.map((el) => {
				return el.field;
			});
			if (filterFields.includes(colName))
				this.config.filterSettings.map((el) => {
					if (el.field == colName) {
						el.value = Number(el.value / 1000000);
					}
				});
		}
	}
}
